import { useContext } from "react";
import { useQueryClient } from "@tanstack/react-query";
import Modal from "react-overlays/Modal";
import Icon from "./icon";
import UserContext from "../context/user";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const DiscardRequestModal = ({
  show,
  closeModal,
  formWatch,
  lastCompletedStep,
  labels,
  skipUpdate = false,
  currentRequest,
  formData,
  setCurrentRequest,
  setCurrentSectionIndex,
  deleteObject = { deleteRequest: () => 0, isError: false, reset: () => 0 },
  updateObject = { updateRequest: () => 0, isError: false },
  createObject = { createRequest: () => 0, isError: false },
}) => {
  const { userProfile } = useContext(UserContext);
  const queryClient = useQueryClient();

  const { deleteRequest, isError, reset } = deleteObject;
  const { updateRequest, isError: isUpdateError } = updateObject;
  const { createRequest, isError: isCreateError } = createObject;

  const handleDeleteRequest = async () => {
    if (currentRequest?.id) {
      await deleteRequest(currentRequest);
    }
    if (!isError) {
      closeModal();
      setCurrentRequest();
      setCurrentSectionIndex();
    }
    reset();
  };

  const handleSaveRequest = async () => {
    if (currentRequest?.surveySubmission?.submissionId) {
      if (skipUpdate) {
        closeModal();
        setCurrentRequest();
        closeModal();
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
      } else {
        await updateRequest(currentRequest, formData, formWatch, lastCompletedStep);
      }
    } else {
      await createRequest(formData, formWatch, lastCompletedStep);
    }
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--borse dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.WELFARE_BORSE_DISCARD_REQUEST || "You're discarding your request"}
          </h1>
          <p className="modal__description">
            {labels?.WELFARE_BORSE_DELETE_REQUEST_TEXT ||
              "Do you want to save the draft for later?"}
          </p>
          <div className="modal__buttons">
            <button className="button secondary" onClick={handleDeleteRequest}>
              {labels?.WELFARE_BORSE_DELETE_DRAFT || "Delete draft"}
              <Icon name="trash" />
            </button>
            <button className="button primary" onClick={handleSaveRequest}>
              {labels?.WELFARE_BORSE_SAVE_DRAFT || "Save draft"}
            </button>
          </div>
          {isError && (
            <p className="modal__error">
              {labels?.WELFARE_BORSE_ERROR_DELETING_REQUEST || "Error deleting request"}
            </p>
          )}
          {(isUpdateError || isCreateError) && (
            <p className="modal__error">
              {labels?.WELFARE_BORSE_ERROR_SAVING_REQUEST || "Error saving request"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default DiscardRequestModal;
